import React, { useState } from 'react';
import { Popover } from 'antd';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Pop.module.scss';

interface IPop {
	placement:
		| 'top'
		| 'left'
		| 'right'
		| 'bottom'
		| 'rightTop'
		| 'rightBottom'
		| 'leftTop'
		| 'leftBottom'
		| 'topLeft'
		| 'topRight'
		| 'bottomLeft'
		| 'bottomRight';
	trigger: 'hover' | 'focus' | 'click';
	content: React.ReactNode;
	title?: string;
	className?: string;
	withCloseIcon?: boolean;
}

const Pop: React.FC<IPop> = React.memo(
	({ children, placement, trigger, content, title, className, withCloseIcon = true }) => {
		const [isOpen, setIsOpen] = useState<boolean>(false);
		const popOverlayClasses = classNames(style.popOverlay, className);

		const handleVisibleChange = (value: boolean) => {
			setIsOpen(value);
		};

		const close = () => {
			setIsOpen(false);
		};

		const renderContent = () => {
			return (
				<div className={style.contentContainer}>
					{withCloseIcon && (
						<div className={style.closeElement} onClick={close}>
							<svg className={style.closeIcon}>
								<use xlinkHref={`${breadcrumbs}#crossMark`} />
							</svg>
						</div>
					)}
					{content}
				</div>
			);
		};

		return (
			<Popover
				overlayClassName={popOverlayClasses}
				overlayInnerStyle={{ borderRadius: '4px' }}
				placement={placement}
				title={title}
				content={renderContent}
				trigger={trigger}
				visible={isOpen}
				onVisibleChange={handleVisibleChange}>
				{children}
			</Popover>
		);
	},
);

export default Pop;
